import { FeedMediaStates, PublishingOptions, RTCClient } from 'utils/webrtc';
import { call } from 'redux-saga/effects';

export function* startRoomBroadcastSaga() {
  const publishingOptions: PublishingOptions = yield call(
    RTCClient.publishingFeed.getJoinPublishingOptions
  );

  // initialize broadcasting based on WebRTC connection state,
  // in most cases the first condition will pass
  if (!RTCClient.publishingFeed.getPeerConnection()) {
    // if no WebRTC connection exists, create new publishing request
    yield call(RTCClient.setupPublishState, publishingOptions, true);
    yield call(RTCClient.publishingFeed.requestPublish);
  } else {
    const mediaStates: FeedMediaStates = yield call(RTCClient.publishingFeed.getMediaStates);
    if (publishingOptions.stream) {
      if (mediaStates.audio.enabled && publishingOptions.audio) {
        yield call(RTCClient.publishingFeed.startAudioBroadcasting);
      }

      yield call(RTCClient.publishingFeed.configureStreamingState, publishingOptions);
    } else {
      const preserveAudio = mediaStates.audio.enabled;

      // @FIXME
      // in the post audio-only broadcast scenario and when we don't have a stream
      // in broadcast setup modal publishingOptions return incorrect data
      // because mediaStates.audio.enabled already true and it enables audio broadcasting
      // therefore reset to false values and don't try to broadcast to match modal's UI
      yield call(RTCClient.publishingFeed.configureStreamingState, {
        audio: false,
        video: false,
      });

      // When a user gets full broadcast permissions after initially broadcasting
      // audio-only, we want to keep their audio enabled rather than reset it.
      // @TODO FIXME find a less hacky way to preserve audio state for this specific case
      if (preserveAudio) {
        RTCClient.publishingFeed.mediaStates.audio.enabled = true;
        yield call(RTCClient.publishingFeed.updateRedux);
      }
    }

    yield call(RTCClient.publishingFeed.cleanupJoinMedia);

    // Update an existing stream with new publishing options.
    // Used when a participant's permissions change, for example when a user
    // who previously had audio-only or video-only permission is promoted
    // to have both audio and video permissions.
    yield call(RTCClient.publishingFeed.requestPublish, {
      stream: publishingOptions.stream,
      media: {
        replaceAudio: publishingOptions.audio,
        replaceVideo: publishingOptions.video,
      },
    });
  }
}
